module.exports = __webpack_public_path__ + "static/media/icon_map.3f603a25.svg";